import { IonContent } from "@ionic/react";
import React from "react";

interface DontwalkmodalProps {
  progress: number;
}

const Dontwalkmodal: React.FC<DontwalkmodalProps> = ({ progress }) => {
  // Circle properties
  const radius = 160; 
  const strokeWidth = 50; 
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <IonContent placeholder={undefined}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "48px",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          padding: "100px 20px",
        }}
      >
        <h2 className="calibrating-text">
          Calibrating
          <span className="dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </h2>
        <div style={{ paddingTop: "48px", paddingBottom: "48px", position: "relative" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="400"
            height="400"
            viewBox="0 0 400 400"
            fill="none"
          >
            {/* Background Circle (White Stroke) */}
            <circle cx="200" cy="200" r={radius} stroke="rgba(255, 255, 255, 0.5)" strokeWidth={strokeWidth} fill="none" />

            {/* Animated Progress Circle (Green Stroke) */}
            <circle
              cx="200"
              cy="200"
              r={radius}
              stroke="green"
              strokeWidth={strokeWidth}
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{
                transition: "stroke-dashoffset 0.5s ease-in-out, stroke 0.5s ease-in-out",
              }}
            />

            {/* Percentage Text */}
            <text
              x="50%"
              y="50%"
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="60px"
              fill="white"
              fontWeight="bold"
            >
              {Math.round(progress)}%
            </text>
          </svg>
        </div>
        <h2 className="calibrating-text">Wait</h2>
      </div>
    </IonContent>
  );
};

export default Dontwalkmodal;
